import { SettingConst } from '../../types';

/**
 * Experiment to enable brand exclusivity agreements
 */
export const ENABLE_BRAND_EXCLUSIVITY_AGREEMENTS_230803 =
  'ENABLE_BRAND_EXCLUSIVITY_AGREEMENTS_230803' as SettingConst<
    'ENABLE_BRAND_EXCLUSIVITY_AGREEMENTS_230803',
    boolean,
    'MAKER' | 'HELP_CENTER'
  >;
